import http from '../common/api';
import {ApiSettings} from "application";

const loadBrandAndBillIssuerData = async (data) => {
  return await http.get(ApiSettings.loadBrandTypeAndBillIssuer, {});
}

export default loadBrandAndBillIssuerData;
